import { useState } from "react";
import { Loader2 } from "lucide-react";
import { Button } from "../ui/button";
import { Textarea } from "../ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from "../ui/dialog";

export const ReasonDialog = ({ open, onOpenChange, title, description, confirmLabel, danger, requireReason = true, hideInput, hideCancel, onConfirm, children }) => {
  const [reason, setReason] = useState("");
  const [busy, setBusy] = useState(false);
  const ok = !requireReason || reason.trim().length >= 5;
  const run = async () => {
    setBusy(true);
    try { if (await onConfirm(reason.trim()) !== false) { setReason(""); onOpenChange(false); } } finally { setBusy(false); }
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="reason-dialog">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          {description && <DialogDescription>{description}</DialogDescription>}
        </DialogHeader>
        {children}
        {!hideInput && <Textarea rows={3} value={reason} onChange={(e) => setReason(e.target.value)} maxLength={1000}
          placeholder={requireReason ? "Alasan (wajib, minimal 5 karakter)" : "Catatan (opsional)"} data-testid="reason-input" />}
        <DialogFooter className="gap-2">
          {!hideCancel && <Button variant="outline" onClick={() => onOpenChange(false)} data-testid="reason-cancel-btn">Batal</Button>}
          <Button disabled={!ok || busy} onClick={run} className={danger ? "bg-red-700 hover:bg-red-800" : "bg-emerald-800 hover:bg-emerald-900"} data-testid="reason-confirm-btn">
            {busy && <Loader2 className="h-4 w-4 mr-2 animate-spin" />}{confirmLabel}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
